import { AlertTriangle } from "lucide-react";

// Reusable non-blocking warning for fields declaring that something REALLY happened.
// Shows only when the given date/datetime is in the future. Never blocks saving.
// Reusable across Terapie / Scadenzario / Mascalcia.
export function isFuture(value) {
  if (!value) return false;
  // Date-only values: compare by calendar day (today is NOT future).
  if (value.length <= 10) {
    const t = new Date();
    const today = `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
    return value > today;
  }
  const d = new Date(value);
  if (isNaN(d.getTime())) return false;
  return d.getTime() > Date.now();
}

export function FutureDateWarning({ value, testId = "future-date-warning" }) {
  if (!isFuture(value)) return null;
  return (
    <p data-testid={testId} className="mt-1 flex items-start gap-1.5 text-xs text-[#B26A00]">
      <AlertTriangle className="h-3.5 w-3.5 shrink-0 mt-0.5" />
      <span>La data inserita è futura. Verifica che sia corretta.</span>
    </p>
  );
}
